function Discord() {
  return null;
}

Discord.externalUrl = 'https://discord.gg/Pcfd3YQjhq';

export default Discord;
